import { ReactComponent as Claim } from './claims.svg'

export default Claim
